import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NbcSharedModule } from "../shared/shared.module";
import { _DepartmentHeaderComponent } from "./grid/dept-header/department-header.component";
import { _GridHeaderComponent } from "./grid/grid-header/grid-header.component";
import { _TimesheetGridRowComponent } from "./grid/grid-row/grid-row.component";
import { TimesheetLayoutComponent } from "./layout/timesheet-layout.component";
import { TimesheetDetailComponent } from "./timesheet-details/timesheet-detail.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { NbcBudgetCodeComponent } from "./components/nbc-budget-code/nbc-budget-code.component";
import { GlAccountComponent } from "./components/glaccount/glaccount.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { ModalTimecardTemplateComponent } from "./components/modal-template/modal-timecard-template.component";
import { ModalMultipleTimecardsComponent } from "./components/modal-multi-timecards/modal-multiple-timecards.component";
import { ModalPayTransactionComponent } from "./components/pay-transactions/modal-pay-transaction.component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { RejectPopoverComponent } from "./components/rejection-popover/reject-popover.component";
import { _GridFilterComponent } from "./grid/grid-filter/grid-filter.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { TimesheetGridComponent } from "./grid/timesheet-grid.component";
import { ModalimportTimecardsComponent } from "./components/modal-import-timecards/modal-import-timecards.component";

@NgModule({
    declarations: [
        TimesheetLayoutComponent,
        TimesheetDetailComponent,
        _TimesheetGridRowComponent,
        _GridHeaderComponent,
        _DepartmentHeaderComponent,
        _GridFilterComponent,
        NbcBudgetCodeComponent,
        GlAccountComponent,
        ModalTimecardTemplateComponent,
        ModalMultipleTimecardsComponent,
        ModalimportTimecardsComponent,
        ModalPayTransactionComponent,
        RejectPopoverComponent,
         TimesheetGridComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        NbcSharedModule,
        DragDropModule,
        BsDropdownModule,
        BsDatepickerModule.forRoot(),
        TypeaheadModule.forRoot(),
        PopoverModule.forRoot(),
    ],
    providers: [],
})
export class TimesheetModule {}
